/**
 * Global Search Selectors
 */

import { createSelector } from '@ufc/core'
import type { GlobalSearchState, SearchResult, SearchResultType } from '../domain/types'

interface RootState {
  globalSearch: GlobalSearchState
}

export const selectGlobalSearch = (state: RootState) => state.globalSearch

export const selectSearchQuery = createSelector(
  selectGlobalSearch,
  (search) => search.query
)

export const selectSearchResults = createSelector(
  selectGlobalSearch,
  (search) => search.results
)

export const selectSearchTotal = createSelector(
  selectGlobalSearch,
  (search) => search.total
)

export const selectSearchIsLoading = createSelector(
  selectGlobalSearch,
  (search) => search.isLoading
)

export const selectSearchError = createSelector(
  selectGlobalSearch,
  (search) => search.error
)

export const selectSearchIsOpen = createSelector(
  selectGlobalSearch,
  (search) => search.isOpen
)

export const selectSearchPortal = createSelector(
  selectGlobalSearch,
  (search) => search.portal
)

function groupResultsByType(results: SearchResult[]) {
  return results.reduce(
    (acc, result) => {
      if (!acc[result.type]) {
        acc[result.type] = []
      }
      acc[result.type].push(result)
      return acc
    },
    {} as Record<SearchResultType, SearchResult[]>
  )
}

export const selectGroupedResults = createSelector(
  selectSearchResults,
  groupResultsByType
)

export const selectHasResults = createSelector(
  selectSearchResults,
  (results) => results.length > 0
)
